import React, {useEffect, useState} from 'react'
import {default as EventtickerRow} from './row';
import {useSelector, useDispatch} from 'react-redux';
import {useFirestore, useFirestoreConnect, useFirebase} from 'react-redux-firebase';
import {env} from '../../constants/Environment';
import * as _ from 'lodash';
import * as EventtickerActions from '../../actions/EventtickerActions';
import {Button, Transition, Loader, Input, Icon, Search} from 'semantic-ui-react';
import {Responsive} from '../Responsive';
import {Searchresult} from './searchresult'
import {NoResults} from './noresults'

export default function Schedule(props) {
    const firestore = useFirestore();
    const firebase = useFirebase();
    const dispatch = useDispatch();
    const listener = useSelector((state) => state.eventticker.get('listener'));
    const loadedUntil = useSelector((state) => state.eventticker.get('loaded_until'));
    const isLoading = useSelector((state) => state.eventticker.get('loadingevents'));
    const [searchValue, setSearchValue] = useState('');

    const searchresult = useSelector((state) => state.eventticker.get('search').toJS());

    useEffect(() => {
        dispatch(EventtickerActions.start_listener(firestore));
        return function(){
            if(listener !== null)
                dispatch(EventtickerActions.stop_listening(listener));
        }
    }, props);

    let events = useSelector((state) => {
        var path = {
            list: ['eventlist'],
            events: ['events']
        };

        var events = [];
        state.eventticker.getIn(path.list).forEach((eventKey) => {
            events.push(state.eventticker.getIn([...path.events, eventKey]).toJS());
        });

        return events;
    });

    let selected = useSelector((state) => state.eventticker.get('selected'));

    if(selected !== null){
        var selectedEvents = [];
        selected.get('eventlist').forEach((eventKey) => {
            selectedEvents.push(selected.getIn(['events', eventKey]).toJS());
        });
    }

    function loadMore(){
        if(loadedUntil !== null){
            dispatch(EventtickerActions.load_events(firestore, loadedUntil));
        }
    }

    function search(){
        let val = searchValue;
        setSearchValue('');
        dispatch(EventtickerActions.search(firestore, searchValue));
    }

    function signOut(){
        firebase.auth().signOut().then(function() {
            // Sign-out successful.
        }).catch(function(error) {
            // An error happened.
        });
    }

    return (
        <div style={{
            backgroundColor: '#000000'
        }}>
        {
            (typeof searchresult['no-results'] !== 'undefined' && searchresult['no-results'])?
                <NoResults />
            :null
        }
        {
            (typeof searchresult.choose !== 'undefined' && searchresult.choose !== null)?
                <Searchresult />
            :null    
        }
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: '55px',
                backgroundColor: '#000000',
                display: 'flex',
                alignItems: 'center'
            }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '15px',
                        paddingRight: '15px',
                        width: '100%'
                    }}>
                        {
                            (selected !== null)?
                                <Responsive desktop tablet>
                                    <Button onClick={(e) => {
                                        dispatch(EventtickerActions.unselect_oe());
                                    }} size="small" icon labelPosition="left" inverted basic>
                                        <Icon name="caret left" />
                                        Alle Events anzeigen
                                    </Button>
                                </Responsive>
                            :
                                null
                        }
                        {
                            (selected !== null)?
                                <Responsive mobile>
                                    <Button onClick={(e) => {
                                        dispatch(EventtickerActions.unselect_oe());
                                    }} size="small" icon inverted basic>
                                        <Icon name="caret left" />
                                    </Button>
                                </Responsive>
                            :
                                null
                        }
                        {
                            (selected !== null)?
                                <div style={{
                                    marginLeft: '20px',
                                    marginRight: '20px',
                                    color: '#FFFFFF',
                                    fontWeight: 'bold',
                                    flexGrow: 1,
                                    textAlign: 'center'
                                }}>
                                    Event {selected.get('plus-id')}
                                </div>
                            :<div style={{
                                    color: '#FFFFFF',
                                    fontWeight: 'bold',
                                    flexGrow: 1
                                }}>
                                    <Input iconPosition='left' disabled={searchresult.searching} loading={searchresult.searching} inverted size="mini" action={{ icon: 'search', onClick: (e) => {
                                            search();
                                        }}} onKeyDown={(e) => {
                                            if(e.keyCode === 13)
                                                search();
                                        }} placeholder="Plus-Nummer suchen" value={searchValue} onChange={(e, {value}) => {
                                            if(!value.match(/^\d+$/) && value !== '')return;
                                            setSearchValue(value);
                                        }} />

                                </div>
                        }
                        <Responsive desktop tablet>
                            <Button onClick={(e) => {
                                signOut();
                            }} size="small" icon labelPosition="left" inverted basic>
                                <Icon name="lock" />
                                Abmelden
                            </Button>
                        </Responsive>
                        <Responsive mobile>
                            <Button onClick={(e) => {
                                signOut();
                            }} size="small" icon inverted basic>
                                <Icon name="lock" />
                            </Button>
                        </Responsive>
                    </div>
            </div>
            <div style={{
                position: 'fixed',
                left: '0px',
                right: '0px',
                bottom: 0,
                top: '55px',
                paddingTop: '10px',
                backgroundColor: '#111111',
                color: '#CCCCCC',
                overflow: 'auto',
                display: (selected !== null)?'none':'flex'
            }}>
                <div style={{
                    width: '100%'
                }}>
                    {
                        (typeof events === 'undefined' || events === null)?
                            null
                        :
                            events.map((event) => {
                                if(typeof event !== 'object')return null;
                                return (
                                    <EventtickerRow key={event.id} event={event}/>
                                )
                            })
                    }
                    {
                        (selected !== null)?
                            null
                        :
                            <div>
                            {
                                (isLoading)?
                                    <Loader active inline='centered' />
                                :
                                    <div style={{
                                        padding: '30px 0px',
                                        textAlign: 'center'
                                    }}>
                                        <Button color='black' onClick={() => {
                                            loadMore();
                                        }}>Ältere Einträge laden</Button>
                                    </div>
                            }
                            </div>
                    }
                </div>
            </div>
            {
                (selected !== null)?
                    <div style={{
                        display: 'flex',
                        position: 'fixed',
                        left: '0px',
                        right: '0px',
                        paddingTop: '10px',
                        bottom: 0,
                        top: '55px',
                        backgroundColor: '#111111',
                        color: '#CCCCCC',
                        overflow: 'auto'
                    }}>
                        <div style={{
                            width: '100%'
                        }}>
                            {
                                (typeof selectedEvents === 'undefined' || selectedEvents === null)?
                                    null
                                :
                                    selectedEvents.map((event) => {
                                        if(typeof event !== 'object')return null;
                                        return (
                                            <EventtickerRow key={event.id} event={event}/>
                                        )
                                    })
                            }
                        </div>
                    </div>
                :null
            }
        </div>
    )
}